// import React, { useState } from "react";
// import { makeStyles } from "@material-ui/core/styles";
// import * as api from "../../api/index";

// const useStyles = makeStyles((theme) => ({
//   card: {
//     maxWidth: 400,
//     margin: "50px auto",
//     padding: theme.spacing(3),
//     textAlign: "center",
//     borderRadius: 12,
//     boxShadow: "0 4px 20px rgba(0,0,0,0.1)",
//     backgroundColor: "#fff",
//   },
//   title: {
//     fontSize: "1.5rem",
//     fontWeight: 600,
//     marginBottom: theme.spacing(2),
//   },
//   previewContainer: {
//     position: "relative",
//     display: "inline-block",
//     marginTop: theme.spacing(2),
//   },
//   avatar: {
//     width: 120,
//     height: 120,
//     objectFit: "contain",
//     border: "1px solid #ccc",
//     borderRadius: 8,
//   },
//   removeButton: {
//     position: "absolute",
//     top: -10,
//     right: -10,
//     backgroundColor: "#fff",
//     border: "none",
//     borderRadius: "50%",
//     width: 24,
//     height: 24,
//     cursor: "pointer",
//     fontWeight: "bold",
//     fontSize: "16px",
//     "&:hover": {
//       backgroundColor: "#eee",
//     },
//   },
//   selectButton: {
//     marginTop: theme.spacing(2),
//     width: 150,
//     height: 50,
//     border: "2px dashed #aaa",
//     borderRadius: 8,
//     cursor: "pointer",
//     display: "flex",
//     alignItems: "center",
//     justifyContent: "center",
//     fontWeight: 500,
//     color: "#555",
//     "&:hover": {
//       borderColor: "#1976d2",
//       color: "#1976d2",
//     },
//   },
//   uploadButton: {
//     marginTop: theme.spacing(3),
//     width: "100%",
//     padding: "10px 0",
//     backgroundColor: "#1976d2",
//     color: "#fff",
//     fontWeight: 600,
//     border: "none",
//     borderRadius: 6,
//     cursor: "pointer",
//     "&:disabled": {
//       backgroundColor: "#ccc",
//       cursor: "not-allowed",
//     },
//   },
//   message: {
//     marginTop: theme.spacing(2),
//     fontSize: "0.9rem",
//   },
// }));

// const CompanyLogo = () => {
//   const classes = useStyles();

//   const [file, setFile] = useState(null);
//   const [preview, setPreview] = useState(null);
//   const [loading, setLoading] = useState(false);
//   const [message, setMessage] = useState("");

//   const handleFileChange = (e) => {
//     const selectedFile = e.target.files[0];
//     if (!selectedFile) return;
//     setFile(selectedFile);

//     const reader = new FileReader();
//     reader.onloadend = () => setPreview(reader.result);
//     reader.readAsDataURL(selectedFile);

//     setMessage("");
//   };

//   const handleUpload = async () => {
//     if (!file) {
//       setMessage("Please select a file!");
//       return;
//     }

//     setLoading(true);
//     setMessage("");

//     try {
//       const reader = new FileReader();
//       reader.onloadend = async () => {
//         const base64 = reader.result.split(",")[1];

//         const response = await fetch("/company-logo/upload", {
//           method: "POST",
//           headers: { "Content-Type": "application/json" },
//           body: JSON.stringify({ logoBase64: base64 }),
//         });

//         const data = await response.json();
//         if (data.success) {
//           setMessage("✅ Logo uploaded successfully!");
//           setFile(null);
//           setPreview(null);
//         } else {
//           setMessage("❌ Upload failed: " + data.message);
//         }
//       };
//       reader.readAsDataURL(file);
//     } catch (error) {
//       console.error("Upload error:", error);
//       setMessage("❌ Upload failed");
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleRemove = () => {
//     setFile(null);
//     setPreview(null);
//     setMessage("");
//   };

//   return (
//     <div className={classes.card}>
//       <div className={classes.title}>Upload Company Logo</div>

//       {preview ? (
//         <div className={classes.previewContainer}>
//           <img src={preview} alt="Logo Preview" className={classes.avatar} />
//           <button onClick={handleRemove} className={classes.removeButton}>
//             ×
//           </button>
//         </div>
//       ) : (
//         <label className={classes.selectButton}>
//           Click to select logo
//           <input
//             type="file"
//             accept="image/*"
//             style={{ display: "none" }}
//             onChange={handleFileChange}
//           />
//         </label>
//       )}

//       <button
//         onClick={handleUpload}
//         disabled={!file || loading}
//         className={classes.uploadButton}
//       >
//         {loading ? "Uploading..." : "Upload Logo"}
//       </button>

//       {message && (
//         <div
//           className={classes.message}
//           style={{ color: message.includes("✅") ? "green" : "red" }}
//         >
//           {message}
//         </div>
//       )}
//     </div>
//   );
// };

// export default CompanyLogo;


// import React, { useState, useEffect } from "react";
// import { makeStyles } from "@material-ui/core/styles";
// import { uploadLogo, getLogo } from "../../api/index";

// const useStyles = makeStyles((theme) => ({

//   container: {
//     display: "flex",
//     gap: 20,
//     marginTop: 20,
//   },
  
//   leftSection: {
//     flex: 1,
//     display: "flex",
//     flexDirection: "column",
//     gap: 20,
//   },
  
//   rightSection: {
//     flex: 1.3,
//     border: "1px solid #ddd",
//     borderRadius: 10,
//     minHeight: 250,
//     display: "flex",
//     alignItems: "center",
//     justifyContent: "center",
//     position: "relative",
//   },
  
//   largePreview: {
//     maxWidth: "100%",
//     maxHeight: 300,
//     borderRadius: 8,
//     objectFit: "contain",
//   },
  
//   previewWrapper: {
//     position: "relative",
//   },
  
//   removeButton: {
//     position: "absolute",
//     top: 10,
//     right: 10,
//     background: "#ff4d4d",
//     border: "none",
//     color: "white",
//     borderRadius: "50%",
//     width: 28,
//     height: 28,
//     cursor: "pointer",
//     fontSize: 16,
//     display: "flex",
//     justifyContent: "center",
//     alignItems: "center",
//   },
  
//   existingLogoBox: {
//     marginTop: 10,
//     display: "flex",
//     flexDirection: "column",
//     gap: 10,
//   },
  
//   existingLogo: {
//     width: 100,
//     height: 100,
//     objectFit: "contain",
//     border: "1px solid #ddd",
//     padding: 5,
//     borderRadius: 8,
//   },
  
//   card: {
//     maxWidth: 400,
//     margin: "50px auto",
//     padding: theme.spacing(3),
//     textAlign: "center",
//     borderRadius: 12,
//     boxShadow: "0 4px 20px rgba(0,0,0,0.1)",
//     backgroundColor: "#fff",
//   },
//   title: {
//     fontSize: "1.5rem",
//     fontWeight: 600,
//     marginBottom: theme.spacing(2),
//   },
//   previewContainer: {
//     position: "relative",
//     display: "inline-block",
//     marginTop: theme.spacing(2),
//   },
//   avatar: {
//     width: 90,
//     height: 90,
//     objectFit: "contain",
//     border: "1px solid #ccc",
//     borderRadius: 8,
//   },
//   removeButton: {
//     position: "absolute",
//     top: -10,
//     right: -10,
//     backgroundColor: "#fff",
//     border: "none",
//     borderRadius: "50%",
//     width: 24,
//     height: 24,
//     cursor: "pointer",
//     fontWeight: "bold",
//     fontSize: "16px",
//     "&:hover": {
//       backgroundColor: "#eee",
//     },
//   },
//   selectButton: {
//     marginTop: theme.spacing(2),
//     width: "100%",
//     height: 50,
//     border: "2px dashed #aaa",
//     borderRadius: 8,
//     cursor: "pointer",
//     display: "flex",
//     alignItems: "center",
//     justifyContent: "center",
//     fontWeight: 500,
//     color: "#555",
//     "&:hover": {
//       borderColor: "#1976d2",
//       color: "#1976d2",
//     },
//   },
//   uploadButton: {
//     marginTop: theme.spacing(3),
//     width: "100%",
//     padding: "10px 0",
//     backgroundColor: "#1976d2",
//     color: "#fff",
//     fontWeight: 600,
//     border: "none",
//     borderRadius: 6,
//     cursor: "pointer",
//     "&:disabled": {
//       backgroundColor: "#ccc",
//       cursor: "not-allowed",
//     },
//   },
//   message: {
//     marginTop: theme.spacing(2),
//     fontSize: "0.9rem",
//   },
// }));

// const CompanyLogo = () => {
//   const classes = useStyles();

//   const [file, setFile] = useState(null);
//   const [preview, setPreview] = useState(null);
//   const [loading, setLoading] = useState(false);
//   const [message, setMessage] = useState("");

//   // Load existing company logo
//   useEffect(() => {
//     const fetchLogo = async () => {
//       try {
//         const { data } = await getLogo();

//         if (data?.company?.logoBase64) {
//           setPreview(`data:image/png;base64,${data.company.logoBase64}`);
//         }
//       } catch (err) {
//         console.error("Failed to load logo:", err);
//       }
//     };
//     fetchLogo();
//   }, []);

//   // When a new file is selected
//   const handleFileChange = (e) => {
//     const selectedFile = e.target.files[0];
//     if (!selectedFile) return;

//     setFile(selectedFile);
//     setMessage("");

//     const reader = new FileReader();
//     reader.onloadend = () => setPreview(reader.result);
//     reader.readAsDataURL(selectedFile);
//   };

//   // Upload handler
//   const handleUpload = async () => {
//     if (!file) {
//       setMessage("Please select a file!");
//       return;
//     }

//     setLoading(true);
//     setMessage("");

//     try {
//       const reader = new FileReader();
//       reader.onloadend = async () => {
//         const base64 = reader.result.split(",")[1];

//         const { data } = await uploadLogo(base64);

//         if (data.success) {
//           setMessage("✅ Logo uploaded successfully!");

//           // instantly show preview
//           setPreview(`data:image/png;base64,${base64}`);

//           // allow re-upload (do NOT clear preview)
//           setFile(null);
//         } else {
//           setMessage("❌ Upload failed: " + data.message);
//         }
//       };

//       reader.readAsDataURL(file);
//     } catch (err) {
//       console.error(err);
//       setMessage("❌ Upload failed");
//     } finally {
//       setLoading(false);
//     }
//   };

//   // Clear preview and file
//   const handleRemove = () => {
//     setFile(null);
//     setPreview(null);
//     setMessage("");
//   };

//   return (
//     <div className={classes.card}>
//     <div className={classes.title}>Upload Company Logo</div>
  
//     <div className={classes.container}>
//       {/* LEFT SIDE - Upload UI */}
//       <div className={classes.leftSection}>
//         <label className={classes.selectButton}>
//           Select logo
//           <input
//             type="file"
//             accept="image/*"
//             style={{ display: "none" }}
//             onChange={handleFileChange}
//           />
//         </label>
  
//         <button
//           onClick={handleUpload}
//           disabled={loading || !preview}
//           className={classes.uploadButton}
//         >
//           {loading ? "Uploading..." : "Upload Logo"}
//         </button>
  
//         {message && (
//           <div
//             className={classes.message}
//             style={{ color: message.includes("✅") ? "green" : "red" }}
//           >
//             {message}
//           </div>
//         )}
//       </div>
  
//       {/* RIGHT SIDE - Large Preview */}
//       <div className={classes.rightSection}>
//         {preview ? (
//           <div className={classes.previewWrapper}>
//             <img src={preview} alt="Preview" className={classes.largePreview} />
//             <button onClick={handleRemove} className={classes.removeButton}>
//               ×
//             </button>
//           </div>
//         ) : (
//           <div className={classes.noPreview}>No image selected</div>
//         )}
//       </div>
//     </div>
//     </div>
  
//   );
// };


// export default CompanyLogo;


// import React, { useEffect, useState } from "react";
// import { makeStyles } from "@material-ui/core/styles";
// import { getLogo, uploadLogo } from "../../api"; // adjust path
// import Spinner from "../Spinner/Spinner";

// const useStyles = makeStyles((theme) => ({
//   container: {
//     display: "flex",
//     gap: 20,
//     marginTop: 20,
//   },

//   leftSection: {
//     flex: 1,
//     display: "flex",
//     flexDirection: "column",
//     gap: 20,
//   },

//   rightSection: {
//     flex: 1.3,
//     border: "1px solid #ddd",
//     borderRadius: 10,
//     minHeight: 250,
//     display: "flex",
//     alignItems: "center",
//     justifyContent: "center",
//     position: "relative",
//     padding: 15,
//   },

//   largePreview: {
//     maxWidth: "100%",
//     maxHeight: 300,
//     borderRadius: 8,
//     objectFit: "contain",
//   },

//   previewWrapper: {
//     position: "relative",
//   },

//   removeSmallBtn: {
//     position: "absolute",
//     top: -10,
//     right: -10,
//     backgroundColor: "#fff",
//     border: "none",
//     borderRadius: "50%",
//     width: 24,
//     height: 24,
//     cursor: "pointer",
//     fontWeight: "bold",
//     fontSize: "16px",
//     "&:hover": {
//       backgroundColor: "#eee",
//     },
//   },

//   card: {
//     maxWidth: 800,
//     margin: "50px auto",
//     padding: theme.spacing(3),
//     textAlign: "center",
//     borderRadius: 12,
//     boxShadow: "0 4px 20px rgba(0,0,0,0.1)",
//     backgroundColor: "#fff",
//   },

//   title: {
//     fontSize: "1.5rem",
//     fontWeight: 600,
//     marginBottom: theme.spacing(2),
//   },

//   avatar: {
//     width: 90,
//     height: 90,
//     objectFit: "contain",
//     border: "1px solid #ccc",
//     borderRadius: 8,
//   },

//   selectButton: {
//     marginTop: theme.spacing(2),
//     width: "100%",
//     height: 50,
//     border: "2px dashed #aaa",
//     borderRadius: 8,
//     cursor: "pointer",
//     display: "flex",
//     alignItems: "center",
//     justifyContent: "center",
//     fontWeight: 500,
//     color: "#555",
//     "&:hover": {
//       borderColor: "#1976d2",
//       color: "#1976d2",
//     },
//   },

//   uploadButton: {
//     marginTop: theme.spacing(3),
//     width: "100%",
//     padding: "10px 0",
//     backgroundColor: "#1976d2",
//     color: "#fff",
//     fontWeight: 600,
//     border: "none",
//     borderRadius: 6,
//     cursor: "pointer",
//     "&:disabled": {
//       backgroundColor: "#ccc",
//       cursor: "not-allowed",
//     },
//   },

//   message: {
//     marginTop: theme.spacing(2),
//     fontSize: "0.9rem",
//   },

//   noPreview: {
//     color: "#999",
//     fontSize: 14,
//   },
// }));

// const CompanyLogo = () => {
//   const classes = useStyles();

//   const [file, setFile] = useState(null);
//   const [preview, setPreview] = useState(null);        // NEW selected image
//   const [existingLogo, setExistingLogo] = useState(null); // EXISTING logo from API
//   const [loading, setLoading] = useState(false);
//   const [message, setMessage] = useState("");

//   // Load existing logo
//   useEffect(() => {
//     const fetchLogo = async () => {
//       try {
//         const { data } = await getLogo();

//         if (data?.logoBase64) {
//           setExistingLogo(`data:image/png;base64,${data.logoBase64}`);
//         }
        
//       } catch (err) {
//         console.error("Failed to load logo:", err);
//       }
//     };
//     fetchLogo();
//   }, []);

//   // When user selects new image
//   const handleFileChange = (e) => {
//     const selectedFile = e.target.files[0];
//     if (!selectedFile) return;

//     setFile(selectedFile);
//     setMessage("");

//     const reader = new FileReader();
//     reader.onloadend = () => setPreview(reader.result); // ONLY update preview
//     reader.readAsDataURL(selectedFile);
//   };

//   // Upload new logo
//   const handleUpload = async () => {
//     if (!file) {
//       setMessage("Please select a file!");
//       return;
//     }

//     setLoading(true);
//     setMessage("");

//     const reader = new FileReader();
//     reader.onloadend = async () => {
//       try {
//         const base64 = reader.result.split(",")[1];
//         const { data } = await uploadLogo(base64);

//         if (data.success) {
//           setMessage("✅ Logo uploaded successfully!");

//           // UPDATE RIGHT SIDE IMAGE AFTER UPLOAD
//           setExistingLogo(`data:image/png;base64,${base64}`);

//           // clear selected file but keep preview for left side
//           setPreview(null);
//           setFile(null);

//         } else {
//           setMessage("❌ Upload failed: " + data.message);
//         }
//       } catch (err) {
//         console.error(err);
//         setMessage("❌ Upload failed");
//       } finally {
//         setLoading(false);
//       }
//     };

//     reader.readAsDataURL(file);
//   };

//   return (
//     <div className={classes.card}>
//       <div className={classes.title}>Upload Company Logo</div>

//       <div className={classes.container}>
//         {/* LEFT SIDE */}
//         <div className={classes.leftSection}>
//           <label className={classes.selectButton}>
//             Select logo
//             <input
//               type="file"
//               accept="image/*"
//               style={{ display: "none" }}
//               onChange={handleFileChange}
//             />
//           </label>

//           {/* Left small preview */}
//           {preview && (
//             <img src={preview} alt="Preview" className={classes.avatar} />
//           )}

//           <button
//             onClick={handleUpload}
//             disabled={loading || !file}
//             className={classes.uploadButton}
//           >
//             {loading ? "Uploading..." : "Upload Logo"}
//           </button>

//           {message && (
//             <div
//               className={classes.message}
//               style={{ color: message.includes("✅") ? "green" : "red" }}
//             >
//               {message}
//             </div>
//           )}
//         </div>

//         {/* RIGHT SIDE - EXISTING LOGO */}
//         <div className={classes.rightSection}>
//           {existingLogo ? (
//             <img
//               src={existingLogo}
//               alt="Company Logo"
//               className={classes.largePreview}
//             />
//           ) : (
//             <div className={classes.noPreview}>No uploaded logo</div>
//           )}
//         </div>
//       </div>
//     </div>
//   );
// };


// export default CompanyLogo;


import React, { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { getLogo, uploadLogo } from "../../api";
import Spinner from "../Spinner/Spinner";

const useStyles = makeStyles((theme) => ({
  messageBox: {
    padding: "12px 18px",
    marginTop: 12,
    borderRadius: 8,
    fontSize: 14,
    fontWeight: 500,
    display: "inline-block",
    animation: "$fadeIn 0.3s ease-in-out",
    boxShadow: "0px 2px 8px rgba(0,0,0,0.1)",
  },

  success: {
    background: "#e9f9ef",
    color: "#0b8a2f",
    borderLeft: "4px solid #0b8a2f",
  },

  error: {
    background: "#fdeaea",
    color: "#c62828",
    borderLeft: "4px solid #c62828",
  },

  // Keyframes must be inside JSS using $ syntax
  "@keyframes fadeIn": {
    from: {
      opacity: 0,
      transform: "translateY(4px)",
    },
    to: {
      opacity: 1,
      transform: "translateY(0)",
    },
  },

  container: {
    display: "flex",
    gap: 20,
    marginTop: 20,
  },

  leftSection: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    gap: 20,
  },

  rightSection: {
    flex: 1.3,
    border: "1px solid #ddd",
    borderRadius: 10,
    minHeight: 250,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    position: "relative",
    padding: 15,
  },

  overlay: {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    background: "rgba(255,255,255,0.7)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 10,
  },

  largePreview: {
    maxWidth: "100%",
    maxHeight: 300,
    borderRadius: 8,
    objectFit: "contain",
  },

  avatar: {
    width: 90,
    height: 90,
    objectFit: "contain",
    border: "1px solid #ccc",
    borderRadius: 8,
  },

  card: {
    maxWidth: 800,
    margin: "50px auto",
    padding: theme.spacing(3),
    textAlign: "center",
    borderRadius: 12,
    boxShadow: "0 4px 20px rgba(0,0,0,0.1)",
    backgroundColor: "#fff",
  },

  title: {
    fontSize: "1.5rem",
    fontWeight: 600,
    marginBottom: theme.spacing(2),
  },

  selectButton: {
    marginTop: theme.spacing(2),
    width: "100%",
    height: 50,
    border: "2px dashed #aaa",
    borderRadius: 8,
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontWeight: 500,
    color: "#555",
    "&:hover": {
      borderColor: "#1976d2",
      color: "#1976d2",
    },
  },

  uploadButton: {
    marginTop: theme.spacing(3),
    width: "100%",
    padding: "10px 0",
    backgroundColor: "#1976d2",
    color: "#fff",
    fontWeight: 600,
    border: "none",
    borderRadius: 6,
    cursor: "pointer",
    "&:disabled": {
      backgroundColor: "#ccc",
      cursor: "not-allowed",
    },
  },

  message: {
    marginTop: theme.spacing(2),
    fontSize: "0.9rem",
  },

  noPreview: {
    color: "#999",
    fontSize: 14,
  },
}));

const CompanyLogo = () => {
  const classes = useStyles();

  const [file, setFile] = useState(null);
  const [preview, setPreview] = useState(null);
  const [existingLogo, setExistingLogo] = useState(null);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");

  useEffect(() => {
    const fetchLogo = async () => {
      setLoading(true);
      try {
        const { data } = await getLogo();

        if (data?.logoBase64) {
          setExistingLogo(`data:image/png;base64,${data.logoBase64}`);
        }
      } catch (err) {
        console.error("Failed to load logo:", err);
      }
      setLoading(false);
    };

    fetchLogo();
  }, []);

  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    if (!selectedFile) return;

    setFile(selectedFile);
    setMessage("");

    const reader = new FileReader();
    reader.onloadend = () => setPreview(reader.result);
    reader.readAsDataURL(selectedFile);
  };

  const handleUpload = async () => {
    if (!file) {
      setMessage("Please select a file!");
      return;
    }

    setLoading(true);
    setMessage("");

    const reader = new FileReader();
    reader.onloadend = async () => {
      try {
        const base64 = reader.result.split(",")[1];
        const { data } = await uploadLogo(base64);

        if (data.success) {
          setMessage("✅ Logo uploaded successfully!");
          setExistingLogo(`data:image/png;base64,${base64}`);
          setPreview(null);
          setFile(null);
        } else {
          setMessage("❌ Upload failed: " + data.message);
        }
      } catch (err) {
        console.error(err);
        setMessage("❌ Upload failed");
      }
      setLoading(false);
    };

    reader.readAsDataURL(file);
  };

  return (
    <div className={classes.card}>
      <div className={classes.title}>Upload Company Logo</div>

      {loading && (
        <div className={classes.overlay}>
          <Spinner />
        </div>
      )}

      <div className={classes.container}>
        {/* LEFT SIDE */}
        <div className={classes.leftSection}>
          <label className={classes.selectButton}>
            Select logo
            <input
              type="file"
              accept="image/*"
              style={{ display: "none" }}
              onChange={handleFileChange}
            />
          </label>

          {preview && (
            <img src={preview} alt="Preview" className={classes.avatar} />
          )}

          <button
            onClick={handleUpload}
            disabled={loading || !file}
            className={classes.uploadButton}
          >
            Upload Logo
          </button>

          {message && (
            <div
              className={`${classes.messageBox} ${
                message.includes("✅") ? classes.success : classes.error
              }`}
            >
              {message}
            </div>
          )}

        </div>

        {/* RIGHT SIDE */}
        <div className={classes.rightSection}>
          {existingLogo ? (
            <img
              src={existingLogo}
              alt="Company Logo"
              className={classes.largePreview}
            />
          ) : (
            <div className={classes.noPreview}>No uploaded logo</div>
          )}
        </div>
      </div>
    </div>
  );
};

export default CompanyLogo;
